"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsuredValuableItem = void 0;
class InsuredValuableItem {
}
exports.InsuredValuableItem = InsuredValuableItem;
//# sourceMappingURL=InsuredValuableItem.js.map